import { EnumDescriptions } from '@/app/shared/utils';

export enum CardBrand {
  Visa = 1,
  Mastercard = 2,
  Amex = 3,
  Aura = 4,
  Diners = 5,
  Hipercard = 6,
  Elo = 7,
}
EnumDescriptions.setDescriptions(CardBrand, [
  'Visa',
  'Mastercard',
  'Amex',
  'Aura',
  'Diners',
  'Hipercard',
  'Elo',
]);
